import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

export const BEFI20_DISABLE_ERROR_REGEX = /is not enabled/i;

interface SurveyDTO {
  surveyId: string;
  advisorName: string;
  clientName: string;
  questions: string[];
}

const fetchSurvey = async (clientId?: number): Promise<SurveyDTO> => {
  const [data] = await Promise.all([
    authFetch(urlWithParams('/BeFi20/Survey', { clientId }), {
      headers: { 'Content-type': 'application/json' },
    }),
    new Promise(r => setTimeout(r, 1000)),
  ]);

  return data;
};

export const useSurveyQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.survey(clientId),

    () => fetchSurvey(clientId),

    {
      cacheTime: 0,

      retry(failureCount, error) {
        // Do not retry when BeFi20 is disabled
        return !(BEFI20_DISABLE_ERROR_REGEX.test(error.message) || failureCount > 2);
      },
    },
  );
};
